import { useState, useEffect } from 'react';
export { questionsHandle as handle } from '../routeMetadata';
import Markdown from 'react-markdown';
import { TAN_BG } from '../data/constants';

interface FAQ {
  id: string;
  question: string;
  answer: string;
  display_order: number;
}

export default function FAQPage() {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFaqs = async () => {
      const res = await fetch('/.netlify/functions/public-api?endpoint=faqs');
      const { faqs: data } = res.ok ? await res.json() : { faqs: [] };

      setFaqs((data || []) as FAQ[]);
      setLoading(false);
    };
    fetchFaqs();
  }, []);

  return (
    <main className="min-h-screen" style={{ backgroundColor: TAN_BG }}>
      <div className="container mx-auto px-4 py-12 max-w-[800px]">
        <h1 className="text-4xl font-bold mb-6 text-center">Frequently Asked Questions</h1>

        {loading ? (
          <div className="text-center text-gray-500 py-12">Loading...</div>
        ) : faqs.length === 0 ? (
          <div className="text-center text-gray-500 py-12">No FAQs available yet.</div>
        ) : (
          <div className="space-y-6">
            {faqs.map(faq => (
              <div key={faq.id}>
                <h3 className="font-semibold text-lg mb-1">{faq.question}</h3>
                <div className="prose prose-sm max-w-none [&_a]:text-blue-700 [&_a]:underline">
                  <Markdown>{faq.answer}</Markdown>
                </div>
              </div>
            ))}
          </div>
        )}

        <section className="mx-auto my-10 text-center">
          <p className="text-lg font-semibold">
            Still have questions? Email us at
            {' '}
            <a href="mailto:support@bidetny.com" className="text-blue-700 underline">support@bidetny.com</a>
          </p>
        </section>
      </div>
    </main>
  );
}
